import { Suspense, lazy } from "react";
import t from "prop-types";

import { Route, Switch } from "react-router-dom";
import FullScreenLoading from "@app/common/components/FullScreenLoad";

const TreatmentPage = lazy(() => import("./containers/treatment"));

const propTypes = {
  match: t.object,
};

const TreatmentRoutes = props => (
  <Switch>
    <Route
      exact
      path={`${props.match.path}/:treatmentId/:studentId?`}
      render={innerProps => (
        <Suspense fallback={<FullScreenLoading />}>
          <TreatmentPage {...innerProps} />
        </Suspense>
      )}
    />
  </Switch>
);

TreatmentRoutes.propTypes = propTypes;

export default TreatmentRoutes;
